import React from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { SnackbarProvider as SnackbarProviderMaterial } from "notistack"
import { Check, Close } from "@mui/icons-material"
import { WarningIcon } from "../../../icons"

export interface SnackbarProviderProps {
  children: JSX.Element | JSX.Element[]
}

export const SnackbarProvider = (props: SnackbarProviderProps) => {
  const { children } = props
  const iconStyle = {
    marginRight: theme.spacing.s,
    width: theme.iconSize.l,
    height: theme.iconSize.l,
  }

  return (
    <CustomSnackbarProvider
      maxSnack={3}
      iconVariant={{
        success: <Check style={iconStyle} />,
        warning: <WarningIcon style={iconStyle} />,
        error: <Close style={iconStyle} />,
      }}
      anchorOrigin={theme.ui.snackbar.anchorOrigin}
    >
      {children}
    </CustomSnackbarProvider>
  )
}

const CustomSnackbarProvider = styled(SnackbarProviderMaterial)`
  &.SnackbarContent-root {
    font-size: ${theme.fontSize.m};
    line-height: ${theme.lineHeight.m};
    min-width: 500px;
    height: 56px;

    ${theme.mui.breakpoints.down("sm")} {
      min-width: initial;
      height: auto;
    }
  }
  &[class*="variantSuccess"] {
    background-color: ${theme.color.success};
  }

  &[class*="variantError"] {
    background-color: ${theme.color.error};
  }

  &[class*="variantWarning"] {
    background-color: ${theme.color.warning};
  }
`
